import { render, staticRenderFns } from "./bankOnline.vue?vue&type=template&id=c0a35378"
import script from "./bankOnline.vue?vue&type=script&lang=js"
export * from "./bankOnline.vue?vue&type=script&lang=js"
import style0 from "./bankOnline.vue?vue&type=style&index=0&id=c0a35378&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports